import { ArbitroGrupo, ArbitroGrupoJSON } from '../ArbitroGrupo/ArbitroGrupo';

export interface ArbitroXArbitroGrupoJSON {
  axag_id: string | null;
  axag_arbid: string;
  axag_arbgid: string;
  arbitroGrupo: ArbitroGrupoJSON;
  __delete: boolean;
}

export class ArbitroXArbitroGrupo {
  protected constructor(
    private id: string | null,
    private arbid: string,
    private arbgid: string,
    private arbitroGrupo: ArbitroGrupo,
    private __delete: boolean
  ) {}

  static createFrom(
    id: string | null,
    arbid: string,
    arbgid: string,
    arbitroGrupo: ArbitroGrupo,
    __delete: boolean
  ) {
    return new this(id, arbid, arbgid, arbitroGrupo, __delete);
  }

  arbitroGrupoIs(ag: ArbitroGrupo): boolean {
    return ag.isIdentifiedBy(String(this.arbgid));
  }

  isIdentifiedBy(anId: string): boolean {
    console.log('COMPARACION', this.id, anId);
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: ArbitroXArbitroGrupo) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ArbitroXArbitroGrupoJSON) {
    return ArbitroXArbitroGrupo.createFrom(
      entity.axag_id,
      entity.axag_arbid,
      entity.axag_arbgid,
      ArbitroGrupo.fromJSON(entity.arbitroGrupo),
      entity.__delete
    );
  }

  toJSON(): ArbitroXArbitroGrupoJSON {
    return {
      axag_id: this.getId(),
      axag_arbid: this.getArbid(),
      axag_arbgid: this.getArbgid(),
      arbitroGrupo: this.getArbitroGrupo().toJSON(),
      __delete: this.get__delete(),
    };
  }

  getId(): string | null {
    return this.id;
  }

  getArbid(): string {
    return this.arbid;
  }

  getArbgid(): string {
    return this.arbgid;
  }

  getArbitroGrupo(): ArbitroGrupo {
    return this.arbitroGrupo;
  }

  get__delete(): boolean {
    return this.__delete;
  }

  setId(value: string | null): void {
    this.id = value;
  }

  setArbid(value: string): void {
    this.arbid = value;
  }

  setArbgid(value: string): void {
    this.arbgid = value;
  }

  setArbitroGrupo(value: ArbitroGrupo): void {
    this.arbitroGrupo = value;
  }

  set__delete(value: boolean): void {
    this.__delete = value;
  }
}
